import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IEnvConfigFeature, ProductionType } from '@tencent/chart-drawer-components/lib/interface';


@Feature({
    name: 'EnvConfigFeature',
    adapters: [SLIDE_ADAPTER],
    provide: IEnvConfigFeature,
})
export class EnvConfigFeature implements IEnvConfigFeature {
    public getProductionType(): ProductionType {
        return ProductionType.Slide;
    }
}
